module.exports = __webpack_public_path__ + "static/media/Data_insight_mo_1-1.00a3160e.svg";